import React, { useContext, useEffect, useState, useCallback } from "react";
import classNames from "lib/classNames";
import styles from "styles/charge_approval.module.scss";
import Modal from "./Modal";
import ShopContext from "context/ShopContext";
import { Redirect } from "@shopify/app-bridge/actions";

import EmbeddedContext from "context/EmbeddedContext";

const ChargeApproval = ({}) => {
  const { AppBridgeRedirect } = useContext(EmbeddedContext);
  const shopContext = useContext(ShopContext);
  const {
    state: { chargeConfirmationUrl, redirectToChargeApproval }
  } = shopContext;

  const [isModalVisible, setIsModalVisible] = useState(
    redirectToChargeApproval
  );
  const [isExpanded, setIsExpanded] = useState(false);

  const redirect = () => {
    AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, chargeConfirmationUrl);
  };
  return (
    <div className={classNames("absolute z-50")}>
      <Modal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        style={{ minWidth: "900px", minHeight: "485px" }}
        background="bg-white"
      >
        {(close, setTitle) => (
          <div
            id="monster-upsell-cart"
            className={classNames("px-4 h-full w-full ")}
          >
            <div
              className={`${classNames(" h-full w-full")} ${styles.navy_color}`}
            >
              <div
                className={classNames(
                  "p-4 font-bold flex-center text-2xl pt-0"
                )}
              >
                {" "}
                MonsterUpsells Cart Drawer - Pricing Information{" "}
              </div>
              <div
                className={`${classNames(
                  "rounded-lg p-4 my-4 leading-none flex-center"
                )} ${styles.bg_light_blue_color}`}
                role="alert"
              >
                <span
                  className={`${classNames(
                    " flex rounded-full  uppercase px-3 py-1 text-xs font-bold mr-3 text-white"
                  )} ${styles.bg_blue_color}`}
                >
                  Congrats
                </span>
                <span className={classNames("font-semibold mr-2 text-left")}>
                  You're minutes away from increasing your revenue by up to
                  20%... CHA CHING!
                </span>
              </div>
              <div className={classNames("py-3")}>
                <p>
                  Your membership starts with a 10-day trial. Customize your
                  cart in a few steps and start upselling for free. After those
                  10 days, pricing plans start at $7.99/month and increase
                  incrementally depending on how many orders are placed through
                  your store.{" "}
                </p>

                <div
                  className={classNames("flex items-center cursor-pointer")}
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  <h2 className={classNames("my-4 text-xl font-bold")}>
                    Pricing table
                  </h2>
                  <svg
                    className={`${classNames("duration-300", {
                      "transform ": isExpanded,
                      "rotate-180": isExpanded
                    })}`}
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.2625 10.7375L15 16.4625L20.7375 10.7375L22.5 12.5L15 20L7.5 12.5L9.2625 10.7375Z"
                      fill="#152045"
                    />
                  </svg>
                </div>
                <div
                  className={`${classNames("flex justify-center ", {
                    "pb-6": isExpanded
                  })} ${styles.table} ${isExpanded ? "" : styles.hidden_table}`}
                >
                  <table
                    className={`${classNames("table-auto w-full")} ${
                      styles.table_rounded
                    }`}
                  >
                    <tbody>
                      <tr>
                        <td
                          className={`${classNames(
                            "border px-4 py-2 font-bold"
                          )} ${styles.bg_lighter_blue_color}`}
                        >
                          Orders
                        </td>
                        <td className={classNames("border px-4 py-2")}>0-50</td>
                        <td
                          className={`${classNames("border px-4 py-2")} ${
                            styles.bg_lighter_blue_color
                          }`}
                        >
                          51-200
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          201-500
                        </td>
                        <td
                          className={`${classNames("border px-4 py-2")} ${
                            styles.bg_lighter_blue_color
                          }`}
                        >
                          501-1000
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          1001-2000
                        </td>
                        <td
                          className={`${classNames("border px-4 py-2")} ${
                            styles.bg_lighter_blue_color
                          }`}
                        >
                          2001-3000
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          +3001
                        </td>
                      </tr>
                      <tr>
                        <td
                          className={`${classNames(
                            "border px-4 py-2 font-bold"
                          )} ${styles.bg_lighter_blue_color}`}
                        >
                          Price
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          $7.99
                        </td>
                        <td
                          className={`${classNames("border px-4 py-2")} ${
                            styles.bg_lighter_blue_color
                          }`}
                        >
                          $14.99
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          $29.99
                        </td>
                        <td
                          className={`${classNames("border px-4 py-2")} ${
                            styles.bg_lighter_blue_color
                          }`}
                        >
                          $49.99
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          $84.99
                        </td>
                        <td
                          className={`${classNames("border px-4 py-2")} ${
                            styles.bg_lighter_blue_color
                          }`}
                        >
                          $99.99
                        </td>
                        <td className={classNames("border px-4 py-2")}>
                          $129.99
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className={classNames("flex justify-center  p-4")}>
                  <a
                    className={`${classNames(
                      "py-3 px-5 font-bold rounded-sm text-white text-sm cursor-pointer"
                    )} ${styles.bg_blue_color}`}
                    onClick={() => redirect()}
                  >
                    Get Access
                  </a>
                </div>
                <div className={classNames("flex justify-center text-center")}>
                  <p>
                    On the next page, you will approve charges for the highest
                    pricing tier (up to $129.99/month).
                    <b className={classNames("font-bold")}>
                      However, we will not charge you $129.99 unless you have
                      more than 3000 orders per month.
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ChargeApproval;
